export default function Section3() {
    return (
        <div id="section-3">
            <div className="title mt-2">
                How to use <span className="text-blue-500">ChatPDF?</span>
            </div>

            <div className="content">
                <div className="col-3 col">
                    <div className="badge">1</div> 
                    <div className="sub-title">Upload your PDF Documents</div>
                    <div className="description">
                        <div>To get started, either drag and drop your PDF or click to upload. Next, ChatPDF will begin processing your file.</div>
                        <div>
                            <img src="/assets/LandingSection3Col1.svg"
                            style={{
                                "width": "100%"
                            }}></img>
                        </div>
                    </div>
                </div>
                <div className="col-3 col">
                    <div className="badge">2</div>
                    <div className="sub-title">Ask Any Question</div>
                    <div className="description">
                        <div>Choose from ChatPDF's sample questions related to your document or create your own. Get instant answers and accurate summaries</div>								
                        <div>
                            <img src="/assets/LandingSection3Col2.svg"
                            style={{
                                "width": "100%"
                            }}></img>
                        </div>
                    </div>
                </div>
                <div className="col-3 col">
                    <div className="badge">3</div>
                    <div className="sub-title">Discover with ChatPDF</div>
                    <div className="description">
                        <div>Learn more with follow-up questions, comments or prompts related to your PDF, Engage with your PDF files, extract information and gain insights.</div>
                        <div>
                            <img src="/assets/LandingSection3Col3.svg"
                            style={{
                                "width": "100%"
                            }}></img>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}